













































































































































































































































































import { EmployeeType } from '@/models';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';
import TimeOffTypePicker from './TimeOffTypePicker.vue';

import Vue from 'vue';
import { mapActions } from 'vuex';

import { ITimeOffExportBalancesParams } from '@/services';

import moment from 'moment';
import { createFile } from '@/utils/helpers';
import ALDialog from '../core/Dialog/ALDialog.vue';
import DatePicker from '../common/DatePicker.vue';
import CountryPicker from '@/components/common/CountryPicker.vue';

export default Vue.extend({
  name: 'TimeOffExportBalancesFilterDialog',

  components: {
    ErrorAlert,
    TimeOffTypePicker,
    ALDialog,
    CountryPicker,
    DatePicker
  },

  data() {
    return {
      EmployeeType,

      dialog: false,
      formValid: false,
      loading: false,

      errorMessage: '',
      detailErrorMessage: '',

      timeOffFilterParams: {} as ITimeOffExportBalancesParams,

      employeeIsActiveOptions: [
        {
          value: true,
          display_name: 'Active'
        },
        {
          value: false,
          display_name: 'Inactive'
        }
      ],

      employeeTypeList: [
        {
          value: EmployeeType.Hourly,
          display_name: 'Hourly'
        },
        {
          value: EmployeeType.Salary,
          display_name: 'Salary'
        }
      ]
    };
  },

  computed: {
    startDateRangeRule() {
      return (start: any) => (end?: Date | string) => {
        if (!start || !end) return true;
        const startDate = new Date(start).valueOf();
        const endDate = new Date(end).valueOf();
        return startDate > endDate || 'Start cannot be greater than end';
      };
    },

    endDateRangeRule() {
      return (end: Date | string | null) => (start?: Date | string) => {
        if (!start || !end) return true;
        const startDate = new Date(start).valueOf();
        const endDate = new Date(end).valueOf();
        return startDate > endDate || 'End cannot be less than start';
      };
    }
  },

  methods: {
    ...mapActions({
      exportTimeOffBalances: 'timeOff/exportTimeOffBalances'
    }),

    open() {
      this.clearAllErrors();
      this.timeOffFilterParams = {} as ITimeOffExportBalancesParams;
      this.dialog = true;
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    close() {
      this.clearAllErrors();
      this.dialog = false;
    },

    async saveTimeOffBalanceExport(): Promise<void> {
      this.clearAllErrors();
      this.loading = true;

      const filterParams = this.timeOffFilterParams;
      filterParams.timeoff__in = filterParams?.timeoff__in?.toString();

      await this.exportTimeOffBalances(filterParams)
        .then(data => {
          createFile(
            data,
            `balances - ${moment(new Date()).format('YYYY-MM-DD-HH-mm-ss')}`,
            'xlsx'
          );
          this.close();
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    }
  }
});
